export const GET_TITLE_PATTERNS = 'GET_TITLE_PATTERNS';
export const GET_TITLE_PATTERN_BY_ID = 'GET_TITLE_PATTERN_BY_ID';
export const UPDATE_TITLE_PATTERN = 'UPDATE_TITLE_PATTERN';
export const DELETE_TITLE_PATTERN = 'DELETE_TITLE_PATTERN';
export const CREATE_TITLE_PATTERN = 'CREATE_TITLE_PATTERN';
